// components/Footer.js
import React from 'react';

const currentYear = new Date().getFullYear();

const Footer = () => (
    <section id="legalnotice">
        <footer  className=" container2 pt-4 text-center mb-0 pb-2">

            <div className="container px-4"><br/>
                <h2 className="text-uppercase text-sm-center" style={{}}>Impressum</h2><br/>
                <b><h6 className="text-xs-center"> Imprint in compliance with tele-media regulations of Germany (§ 5
                    TMG)</h6>
                </b>
                <br/>
                <div className="text-xs-center impressum">
                    Alexander Aprelkin<br/>
                    Offenbachstr. 5<br/>
                    81245 München
                    <br/> <br/>

                    Telefon: 0049 174 3410721<br/>
                    E-Mail: alexander @ aprelkin.com<br/>
                    Umsatzsteuer-ID: DE316449563<br/>
                    <br/>

                    Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br/>
                    Alexander Aprelkin<br/>
                    Offenbachstr. 5<br/>
                    81245 München<br/>
                </div>
                <br/>
                <b><h6 className=" text-xs-center">Urheberrecht</h6></b>
                <div className=" text-xs-center impressum" >
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                    deutschen
                    Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
                    der
                    Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw.
                    Erstellers.
                    Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                    Soweit
                    die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
                    beachtet.
                    Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                    Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
                    Bekanntwerden
                    von
                    Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                    <br/><br/></div>
                <b><h6 className="text-xs-center" >Datenschutz </h6></b>
                <div className=" text-xs-center impressum" >
                Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf
                unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben
                werden,
                erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
                Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin, dass die Datenübertragung im Internet
                (z.B.
                bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor
                dem
                Zugriff durch Dritte ist nicht möglich. Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
                Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und
                Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
                ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
                    Spam-Mails, vor.</div><br/><br/>
                <div className="container text-xs-center pb-0 impressum">
                    <p>&copy; Alexander Aprelkin {currentYear}</p>
                </div>
            </div>
        </footer>
    </section>
);

export default Footer;